const userPrefferenceActions = {
  SET_DARK_MODE: 'SET_DARK_MODE',
  SET_IS_LIST_VIEW: 'SET_IS_LIST_VIEW',
  SET_FILTER_MODE: 'SET_FILTER_MODE',

  setDarkMode: (theme) => (dispatch) => dispatch({ type: userPrefferenceActions.SET_DARK_MODE, payload: theme }),
  setIsListView: (isListView) => (dispatch) => dispatch({ type: userPrefferenceActions.SET_IS_LIST_VIEW, payload: isListView }),
  setFilterMode: (filterMode) => (dispatch) => dispatch({ type: userPrefferenceActions.SET_FILTER_MODE, payload: filterMode }),
};

export default userPrefferenceActions;
